<div class="upload-file-box" *ngIf="displayUploadFileButton && !(files | keyvalue)?.length">
  <button
    class="btn btn-link no-padding"
    [ngClass]="{ 'no-padding': !fileUploadOpen, 'no-height-padding': fileUploadOpen }"
    (click)="clickFileUploadButton()"
    aria-label="{{ 'list.add.item.click_drag_upload_file' | translate }}"
    id="uploadFileButton"
    ng-if="!newItemFileUpload()">
    <span *ngIf="!fileUploadOpen"><i class="fa fa-cloud-upload no-margin" aria-hidden="true"></i> {{ 'list.add.item.click_drag_upload_file' | translate }}</span>
    <span *ngIf="fileUploadOpen">{{ 'general.close' | translate }}</span>
  </button>
</div>
<div *ngIf="fileUploadOpen || !displayUploadFileButton">
  <div
    *ngIf="!(files | keyvalue)?.length"
    ng2FileDrop
    (fileOver)="dragOver = $event"
    (onFileDrop)="upload($event)"
    [uploader]="uploader"
    class="file-drop-zone well my-drop-zone nv-file-over"
    [ngClass]="{ dragOver: 'dragover' }"
    (click)="fileInput.click()"
    (keydown.enter)="fileInput.click()"
    (keydown.space)="fileInput.click()"
    tabindex="0">
    <span class="guidance-text-out">
      {{ dropFileTypeLabel | translate }}
      <br />
      <span class="small">{{ dropSingleOrFolderLabel | translate }}</span>
    </span>
    <span class="guidance-text-on">{{ 'citation.edit.drag.dropIt' | translate }}</span>

    <input type="file" #fileInput ng2FileSelect [uploader]="uploader" (onFileSelected)="upload($event)" [accept]="acceptedTypes" style="display: none" />
  </div>
</div>
<ng-container *ngIf="(files | keyvalue)?.length">
  <div class="file-drop-zone-list-item file-upload-name" *ngFor="let f of files | keyvalue" [ngClass]="{ 'upload-failed': f.errors?.length > 0, 'upload-on-process': f.progress < 100, uploaded: f.progress == 100 }">
    <rl-file-display *ngIf="f.value.fileItem.isSuccess" [file]="f.value"></rl-file-display>
    <!-- ************** Progress bar *************** -->
    <div class="file-drop-zone-list" *ngIf="f.value.fileItem.isUploading">
      <!--f.errors?.length == 0 &&-->
      <div class="file-drop-zone-item">
        <div class="file-drop-details">
          <!-- <img class="thumb" [hidden]="!f.dataUrl" [src]="f.dataUrl" [alt]="'citation.edit.abort' | translate"/> -->
          <span
            >{{ f.value.amazonDisplayFileName }}
            <em>({{ f.value.fileItem.file.size }} bytes)</em>
          </span>
          <div class="progress progress-striped progress-default active">
            <div class="progress-bar" [ngStyle]="{ width: f.value.fileItem.progress + '%' }">{{ f.value.fileItem.progress }}%</div>
          </div>
        </div>
        <!--ng-show="f.upload != null && f.progress < 100 && !f.upload.aborted"-->
        <!-- <button class="btn btn-link btn-icon-only medium-text" (click)="delete(f.value)" [tooltip]="'citation.edit.abort' | translate" attr.aria-label="{{'citation.edit.abort' | translate}}">
                    <i class="fa fa-trash" attr.aria-hidden="true"></i>
                </button> -->
      </div>
    </div>
    <!-- ************** ERROR messages *************** -->
    <div *ngIf="f.errors?.length > 0" class="input-message warning-inverse" role="alert" attr.aria-live="assertive">
      *ngFor="let error of f.errors"
      {{ error | translate }}
    </div>
    <!-- <div ngf-no-file-drop>{{'citation.edit.drag.not.supported' | translate}}</div> -->
    <!-- ************** File completed loading *************** -->
    <!--*ngIf="mode != 'hover' && filename || (fileToUpload && (errorInUpload() || f.upload.aborted))"-->
  </div>
</ng-container>
